<template>
    <a-modal
        id="storyList-modal"
        :title="editMode ? $t('chatbotv2.updateStory') : $t('chatbotv2.newStory')"
        wrapClassName="vertical-center-modal"
        :visible="modalVisible"
        @ok="handleOk()"
        @cancel="handleCancel()"
        :okText="$t('message.ok')"
        :cancelText="$t('message.cancel')"
    >
        <a-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
            <a-form-item
                :label="$t('chatbotv2.storyTitle')"
                :fieldDecoratorOptions="{ rules: [{ required: true, message: 'Please input title of story!' }] }"
            >
                <a-input v-model="form.title" :class="{ 'cls-error': isTitleEmpty }" />
            </a-form-item>
            <a-form-item
                :label="$t('chatbotv2.storyDescription')"
                :fieldDecoratorOptions="{
                    rules: [{ required: true, message: 'Please input a description for story!' }],
                }"
            >
                <a-input v-model="form.description" />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "NewStoryForm",
    props: {
        modalVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            editMode: false,
            isTitleEmpty: false,
            form: {
                title: "",
                description: "",
            },
        };
    },
    methods: {
        ...mapActions({
            createEmptyStory: "CB/createEmptyStory",
            listStories: "CB/listStories",
        }),
        handleSave() {
            if (this.form.title !== "") {
                this.loading = true;
                this.createEmptyStory(this.form)
                    .then(() => this.$emit("modal-visible", false))
                    .finally(() => {
                        this.loading = false;
                        this.isTitleEmpty = false;
                        this.listStories();
                    });
            } else {
                this.isTitleEmpty = true;
                this.$message.error({
                    content: "story title can not be empty!!",
                    duration: 4,
                });
            }
        },
        reset() {
            this.form = {
                title: "",
                description: "",
            };
        },
        handleOk() {
            this.handleSave();
            this.reset();
        },
        handleCancel() {
            this.$emit("modal-visible", false);
            this.reset();
            this.isTitleEmpty = false;
        },
    },
};
</script>

<style lang="scss">
.vertical-center-modal {
    text-align: center;
    white-space: nowrap;
}

.vertical-center-modal:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    width: 0;
}

.vertical-center-modal .ant-modal {
    display: inline-block;
    vertical-align: middle;
    top: 0;
    text-align: left;
}

.cls-error {
    border: 1px solid red;
}
</style>
